var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useImperativeHandle, useState, useEffect } from 'react';
import cn from 'classnames';
import { useUID } from 'react-uid';
import CBUtils from '@cb/apricot/CBUtils';
import { DropdownItem } from './DropdownItem';
import { Input } from '../Input';
// ref is for the wrapping div
export const InputDropdownR = React.forwardRef((_a, ref) => {
    var { labelId, inputId, dropdownId, validationMessageId, ariaDescribedby, type = 'text', label, ariaLabel, validationMsgRole, className, labelClassName, mainClassName, name, floating = true, floatingBg, condensed = false, disabled = false, clearable = true, required, icon, iconRight = false, divAttributes, dropdownOverlay = false, placeholder, dataItems = [], defaultItems = [], openOnLoad = false, showNoItemsText = false, noItemsText = 'no suggestions available', srMessageText = ['suggestion available', 'suggestions available'], defaultValue = '', dropDownItemIcon, dropDownItemIconLeft = false, highlightInputValue = false, dropDownItemAnchorAttributes, dropDownItemClassNameFunc, dropDownItemFunc, scrollLimit = 0, itemHeight = 48, scrollLimitHelper = false, scrollLimitHelperLimit = scrollLimit, scrollLimitHelperText = 'There are more results available. Keep typing to refine your search.', scrollLimitHelperClass, reset, escClose = true, closeOnClickOutside = true, closeOnSelect = true, onReset, onChange, onClear, callBack, itemLabelFunc } = _a, props = __rest(_a, ["labelId", "inputId", "dropdownId", "validationMessageId", "ariaDescribedby", "type", "label", "ariaLabel", "validationMsgRole", "className", "labelClassName", "mainClassName", "name", "floating", "floatingBg", "condensed", "disabled", "clearable", "required", "icon", "iconRight", "divAttributes", "dropdownOverlay", "placeholder", "dataItems", "defaultItems", "openOnLoad", "showNoItemsText", "noItemsText", "srMessageText", "defaultValue", "dropDownItemIcon", "dropDownItemIconLeft", "highlightInputValue", "dropDownItemAnchorAttributes", "dropDownItemClassNameFunc", "dropDownItemFunc", "scrollLimit", "itemHeight", "scrollLimitHelper", "scrollLimitHelperLimit", "scrollLimitHelperText", "scrollLimitHelperClass", "reset", "escClose", "closeOnClickOutside", "closeOnSelect", "onReset", "onChange", "onClear", "callBack", "itemLabelFunc"]);
    const uid = useUID();
    const mainInputRef = useRef(null);
    const inputRef = useRef(null);
    const inputDropdownItemContainerRef = useRef(null);
    const helperTextRef = useRef(null);
    const didMount = React.useRef(false);
    // eslint-disable-next-line no-param-reassign
    inputId = inputId || `apricot_input_dropdown_${uid}`;
    // eslint-disable-next-line no-param-reassign
    dropdownId = dropdownId || `apricot_dropdown_${uid}`;
    // eslint-disable-next-line no-param-reassign
    labelId = labelId || `apricot_label_${uid}`;
    // eslint-disable-next-line no-param-reassign
    validationMessageId = validationMessageId || `apricot_input_err_${uid}`;
    useImperativeHandle(ref, () => inputRef.current);
    const [isOpen, setIsOpen] = useState(false);
    const [clickEvent, setClickEvent] = useState(false);
    const [hasFocus, setHasFocus] = useState(false);
    const [dropDownDataItem, setDropDownDataItem] = useState(defaultItems || dataItems);
    const [inputValue, setInputValue] = useState(defaultValue);
    const [srMessage, setSrMessage] = useState('');
    const [scrollLimitObj, setScrollLimitObj] = useState({});
    const [showHelper, setShowHelper] = useState(false);
    const [helperContainerObj, setHelperContainerObj] = useState({});
    // open on arrow down
    const inputKeydownEvents = e => {
        // 38: up
        // 40: down
        // 16: shift
        // 9: tab
        const k = e.which || e.keyCode;
        const key = CBUtils.whichKey(e);
        if (key !== 'TAB' && key !== 'DOWN')
            return;
        if (k === 9) {
            setIsOpen(false);
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (k === 40) {
            // Manage Focus
            setIsOpen(true);
            const inputDropdownItemContainer = inputDropdownItemContainerRef.current;
            const inputDropdownItemLi = inputDropdownItemContainer === null || inputDropdownItemContainer === void 0 ? void 0 : inputDropdownItemContainer.querySelectorAll(`#${dropdownId}>li>a`);
            if (inputDropdownItemLi === null || inputDropdownItemLi === void 0 ? void 0 : inputDropdownItemLi.length) {
                let index = 0;
                const itemNode = inputDropdownItemLi[index];
                itemNode.focus();
                Array.prototype.forEach.call(inputDropdownItemLi, (node, i) => {
                    node.addEventListener('keydown', (event) => {
                        var _a, _b;
                        const keyValue = event.which || event.keyCode;
                        index = i;
                        // make sure menus are closed after tab away
                        if (keyValue === 9) {
                            // make sure menus are closed after tab away
                            setIsOpen(false);
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                            index = 0;
                        }
                        if (!/(38|40|16)/.test(keyValue))
                            return;
                        event.preventDefault();
                        event.stopPropagation();
                        // up/down arrows
                        if (keyValue === 38) {
                            index -= 1; // up
                        }
                        else if (keyValue === 40) {
                            index += 1; // down
                        }
                        if (index < 0 && keyValue === 38) {
                            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                            index = 0;
                            return;
                        }
                        if (index < 0 || index === inputDropdownItemLi.length) {
                            index = 0;
                        }
                        const newActive = inputDropdownItemLi[index];
                        newActive.focus();
                    });
                });
            }
        }
    };
    const eventEscape = e => {
        // ESC: 27,
        if (e.keyCode === 27) {
            setIsOpen(false);
            mainInputRef.current && mainInputRef.current.focus();
        }
    };
    const eventFocusOut = () => {
        // we need to pause before closing until we can determine if the focus is really outside this container
        setTimeout(() => {
            if (mainInputRef.current && !mainInputRef.current.contains(document.activeElement)) {
                setHasFocus(false);
                setIsOpen(false);
            }
        }, 200);
    };
    const eventFocusIn = () => {
        // we need to pause before closing until we can determine if the focus is really outside this container
        setTimeout(() => {
            if (mainInputRef.current && !!mainInputRef.current.contains(document.activeElement)) {
                setHasFocus(true);
            }
        }, 200);
    };
    const handleOnChange = (e, value) => {
        // call users change event/filter
        onChange && onChange(e, value);
        // it's a controlled component
        setInputValue(value);
    };
    const clickDropdownItem = (e, itemLabel, itemValue) => {
        var _a, _b;
        e.preventDefault();
        setClickEvent(true);
        if (itemValue !== '') {
            // call external function to set input value
            if (itemLabelFunc) {
                setInputValue(itemLabelFunc(e, itemLabel, itemValue));
            }
            else {
                setInputValue(itemLabel);
            }
        }
        !!closeOnSelect && setIsOpen(false);
        onChange && onChange(e, itemLabel);
        callBack && callBack(itemLabel, itemValue);
        const event1 = new Event('input');
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event1);
        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    };
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };
    const removeScrollLimitHelper = () => {
        setHelperContainerObj({});
        setShowHelper(false);
    };
    const resizeEventHandler = () => {
        if (helperTextRef.current && scrollLimitHelper && isOpen) {
            if (dataItems.length > scrollLimit) {
                if (dataItems.length > scrollLimitHelperLimit) {
                    setHelperContainerObj({
                        minHeight: `${scrollLimit * itemHeight + CBUtils.getHiddenHeight(helperTextRef.current)}px`,
                        paddingBottom: `${CBUtils.getHiddenHeight(helperTextRef.current)}px`,
                    });
                    setShowHelper(true);
                }
                else {
                    setHelperContainerObj({
                        minHeight: `${scrollLimit * itemHeight}px`,
                        paddingBottom: 0,
                    });
                    setShowHelper(false);
                }
            }
            else {
                const height = dataItems.length ? dataItems.length : 0;
                setHelperContainerObj({
                    minHeight: `${height * itemHeight + 8}px`,
                    paddingBottom: 0,
                });
                setShowHelper(false);
            }
        }
        else {
            removeScrollLimitHelper();
        }
    };
    useEffect(() => {
        const container = (mainInputRef === null || mainInputRef === void 0 ? void 0 : mainInputRef.current) || null;
        container === null || container === void 0 ? void 0 : container.addEventListener('focusin', eventFocusIn);
        closeOnClickOutside && (container === null || container === void 0 ? void 0 : container.addEventListener('focusout', eventFocusOut));
        escClose && document.addEventListener('keydown', eventEscape);
        scrollLimit > 0 && setScrollLimitObj({ maxHeight: `${scrollLimit * itemHeight}px` });
        return () => {
            container === null || container === void 0 ? void 0 : container.removeEventListener('focusin', eventFocusIn);
            closeOnClickOutside && (container === null || container === void 0 ? void 0 : container.removeEventListener('focusout', eventFocusOut));
            escClose && document.removeEventListener('keydown', eventEscape);
        };
    }, []);
    useEffect(() => {
        if (didMount.current) {
            if (!dataItems.length) {
                if (showNoItemsText) {
                    setDropDownDataItem([{ label: noItemsText, value: '', noItemText: true }]);
                    setIsOpen(true);
                }
                else {
                    setDropDownDataItem([]);
                    setIsOpen(false);
                }
                if (CBUtils.isBlank(inputValue)) {
                    setSrMessage('');
                }
                else {
                    setSrMessage(noItemsText);
                }
                scrollLimitHelper && resizeEventHandler();
            }
            else {
                setDropDownDataItem(dataItems);
                let msg = '';
                msg = dataItems.length === 1 ? srMessageText[0] : srMessageText[1];
                setSrMessage(`${dataItems.length} ${msg}`);
                if (scrollLimitHelper) {
                    dataItems.length > scrollLimit &&
                        setSrMessage(`${dataItems.length} ${msg}. ${scrollLimitHelperText}`);
                    resizeEventHandler();
                }
                !clickEvent && setIsOpen(true);
                setClickEvent(false);
            }
        }
        else {
            if (dropdownOverlay && scrollLimit > 0 && scrollLimitHelper && defaultItems.length > 0) {
                const height = defaultItems.length < scrollLimit ? defaultItems.length : scrollLimit;
                setHelperContainerObj({
                    minHeight: `${height * itemHeight + 8}px`,
                });
            }
            // open onRender
            openOnLoad && !!defaultItems.length && setIsOpen(true);
            didMount.current = true;
        }
    }, [dataItems]);
    // handle reset
    useEffect(() => {
        if (reset) {
            setInputValue('');
            setDropDownDataItem([]);
            setSrMessage('');
            setClickEvent(false);
            resizeEventHandler();
            onReset && onReset();
        }
    }, [reset]);
    // handle height adjustment
    useEffect(() => {
        if (scrollLimitHelper) {
            if (isOpen && dataItems.length > 0 && !!inputValue) {
                resizeEventHandler();
            }
            else {
                removeScrollLimitHelper();
            }
        }
    }, [isOpen]);
    useEffect(() => {
        if (scrollLimitHelper) {
            const debouncedResizeEventHandler = debounce(resizeEventHandler, 300);
            window.addEventListener('resize', debouncedResizeEventHandler);
            // remove the event on dismount
            return () => {
                window.removeEventListener('resize', debouncedResizeEventHandler);
            };
        }
        return () => {
            window.removeEventListener('resize', resizeEventHandler);
        };
    }, [dataItems, scrollLimitHelper]);
    return (React.createElement(Input, Object.assign({}, props, { ref: inputRef, mainRef: mainInputRef, label: label, id: inputId, mainClassName: cn('cb-input-dropdown', clearable && inputValue && hasFocus && 'cb-value-ci cb-focus-elem-ci', !!dropdownOverlay && 'cb-input-dropdown-overlay', !label || (!floating && 'cb-input-no-label'), !disabled && isOpen && 'cb-open', scrollLimit > 0 && 'cb-input-dropdown-scroll', mainClassName), className: className, labelClassName: cn(labelClassName, floating && inputValue && 'cb-value-fl'), name: name, "aria-label": ariaLabel, placeholder: placeholder, "aria-controls": dropdownId, autoComplete: "off", ariaDescribedby: ariaDescribedby, "aria-haspopup": "listbox", iconRight: iconRight, required: required, icon: icon, type: type, disabled: disabled, condensed: condensed, floating: floating, floatingBg: floatingBg, clearable: clearable, divAttributes: divAttributes, onClear: event => {
            // clear is a change to the value of the input
            const changeEvent = new Event('change');
            inputRef.current && inputRef.current.dispatchEvent(changeEvent);
            onClear && onClear(event);
        }, value: inputValue, "data-cb-value": inputValue, "cb-value-ci": clearable ? inputValue : undefined, onKeyDown: inputKeydownEvents, onChange: (e, value) => {
            // if it's a dropdown item
            if (value) {
                handleOnChange(e, value);
            }
            else {
                handleOnChange(e, e.target.value);
            }
        }, validationMessageId: validationMessageId, validationMsgRole: validationMsgRole, inputWithDropdown: true }),
        React.createElement("div", { className: "cb-dropdown-input" },
            React.createElement("span", { role: "status", className: "cb-dropdown-input-items sr-only" }, srMessage),
            React.createElement("div", { className: cn('cb-dropdown-container', 
                // only if we want to show scroll helper text
                dropdownOverlay && scrollLimit > 0 && scrollLimitHelper && 'cb-has-dropdown-overlay'), style: helperContainerObj },
                React.createElement("div", { className: cn('cb-dropdown-menu', showHelper && 'cb-no-box-shadow'), ref: inputDropdownItemContainerRef, style: scrollLimitObj },
                    React.createElement("ul", { id: dropdownId, role: "listbox", "aria-labelledby": label ? labelId : undefined }, !disabled &&
                        dropDownDataItem &&
                        dropDownDataItem.map((item, index) => {
                            return item.noItemText ? (React.createElement("li", { className: "cb-dropdown-header" },
                                React.createElement("p", { className: "cb-no-suggestion" }, item.label))) : (React.createElement(DropdownItem, { key: `menuitem__${index}`, label: item.label, value: item.value, icon: dropDownItemIcon || item.icon, dropDownItemIconLeft: dropDownItemIconLeft, searchValue: inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString(), highlightInputValue: highlightInputValue, onClickDropdownItem: clickDropdownItem, dropDownItemClassNameFunc: dropDownItemClassNameFunc, dropDownItemAnchorAttributes: dropDownItemAnchorAttributes, dropDownItemFunc: dropDownItemFunc }));
                        }))),
                scrollLimitHelper && (React.createElement("p", { className: cn('cb-dropdown-helper', showHelper && 'cb-show', scrollLimitHelperClass), "aria-hidden": "true", ref: helperTextRef }, scrollLimitHelperText))))));
});
//# sourceMappingURL=InputDropdownR.js.map